import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { switchLanguage } from 'shared/store/actions';
import selectors from 'shared/store/selectors';
import { Button } from 'components';
import styles from './LanguageSwitcher.scss';

const languages = [
  { id: 'EN', name: 'EN' },
  { id: 'AR', name: 'عربي' },
];

const LanguageSwitcher = ({ language, onSwitchLanguage }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(languages[1]);

  const onChangeLanguage = () => {
    switch (selectedLanguage.id) {
      case 'EN':
        setSelectedLanguage(languages[1]);
        // change button from en to ar, change language to en
        onSwitchLanguage();
        break;
      case 'AR':
        setSelectedLanguage(languages[0]);
        // change button from ar to en, change language to ar
        onSwitchLanguage();
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setSelectedLanguage(languages.find(item => item.id !== language.locale));
  }, [language]);

  return (
    <div className={styles.languageSwitcher}>
      <Button isLink onButtonClick={onChangeLanguage} value={selectedLanguage.name} />
    </div>
  );
};

const mapStateToProps = state => ({
  language: selectors.getLanguage(state),
});
const mapDispatchToProps = dispatch => ({
  onSwitchLanguage: () => dispatch(switchLanguage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSwitcher);
